<template>
  <div id="iframe_container">
    <iframe
      v-if="isMetabaseDashboardAvailable"
      id="metabase-dashboard"
      :src="metabaseDashboardUrl"
      frameborder="0"
      style="overflow: hidden;"
    />
    <div
      v-else
      id="fallback-title"
    >
      <h1>
        {{ $t('home.welcome') }}
      </h1>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',

  computed: {
    ...mapState('login', [
      'userData'
    ]),
    isMetabaseDashboardAvailable() {
      return process.env.VUE_APP_METABASE_DASHBOARD_URL && process.env.VUE_APP_METABASE_DASHBOARD_URL !== '';
    },
    metabaseDashboardUrl() {
      let url = process.env.VUE_APP_METABASE_DASHBOARD_URL;
      if (this.userData && this.userData.usergroup_roles && this.userData.usergroup_roles.length) {
        for (const usergroupDisplayName of this.userData.usergroup_roles.map(el => el.usergroup.display_name)) {
          url += `${url.indexOf('?') === -1 ? '?' : '&'}organisation=${usergroupDisplayName}`;
        }
      }
      return url;
    }
  },

  mounted() {
    this.checkIframeLoaded();
  },

  methods: {
    checkIframeLoaded() {
      // Get a handle to the iframe element
      var iframe = document.getElementById('metabase-dashboard');
      if (iframe) {
        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        // Check if loading is complete
        if (  iframeDoc.readyState  == 'complete' ) {
          return;
        } 
        // If we are here, it is not loaded.
        window.setTimeout(this.checkIframeLoaded, 100);
      }
    }
  }
};
</script>

<style lang="less" scoped>
  #iframe_container {
    height: calc(100vh - @headerHeight - @footerHeight);
    margin: 0 auto;
    #metabase-dashboard {
      position: relative;
      height: 100%;
      width: 100%;
    }
  }
  #fallback-title {
    height: calc(100vh - @headerHeight - @footerHeight);
    display: flex;
    justify-content: center;
    h1 {
      color: @blue;
      text-shadow: 1px 1px 2px @blue;
      font-size: 4em;
      margin-top: 15%
    }
  }
</style>
